module.exports = __webpack_public_path__ + "img/list-view-active-icon.5c67f895.svg";